import { TTS_TOUR_GUIDE } from '@src/constants/tourGuide';

const getOldTTSTourGuideKey = () => TTS_TOUR_GUIDE;
const getTTSTourGuideKey = (userId) => `${TTS_TOUR_GUIDE}_${userId}`;

const getTTSTourGuideValue = (userId) => {
  // Previously, tour guide state was stored using a global key (not user-based).
  // To avoid showing the tour guide again for devices/users who have already seen it,
  // we first check the old key.
  const oldKey = getOldTTSTourGuideKey();
  const oldValue = localStorage.getItem(oldKey);
  if (oldValue) return oldValue;

  // New flow: tour guide state is stored per user id
  const key = getTTSTourGuideKey(userId);
  const value = localStorage.getItem(key);
  return value;
};

const setTTSTourGuideValue = (userId, value) => {
  const key = getTTSTourGuideKey(userId);
  localStorage.setItem(key, value);
};

export { getTTSTourGuideValue, setTTSTourGuideValue };
